// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, descending, page, rowsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];
    const fields = params.fields ? params.fields : "";
    const expand = params.expand ? params.expand : "";
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("product-sets", {
        page: page,
        sortBy: sortBy,
        descending: descending,
        rowsPerPage: rowsPerPage,
        search: params.search,
        filter: params.filter,
        fields: fields,
        expand: expand
      })
        .then(({ data }) => {
          context.commit("set_product_sets", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  view(context, params) {
    const { sortBy, descending, page, rowsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];
    const fields = params.fields ? params.fields : "";
    const expand = params.expand ? params.expand : "products,particles";
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("product-sets/" + params.id, {
        page: page,
        sortBy: sortBy,
        descending: descending,
        rowsPerPage: rowsPerPage,
        search: params.search,
        fields: fields,
        expand: expand
      })
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data.set);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  // TODO: Checker si c'est utilisé !
  create(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post("product-sets", params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  delete(context, setId) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.delete("product-sets/"+setId)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("product-sets/" + params.model.id, params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  updateField(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("product-sets/field/" + params.model.id, params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data.model);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  generateParticles(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("product-sets/" + params.id + "/generate-particles", {})
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  getFieldHandles(context) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("product-sets/field-handles", {})
        .then(({ data }) => {
          context.commit("setFieldHandles", data.handles);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  addField(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post(
        "product-sets/" + params.setId + "/fields",
        params.model
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  getPrices(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get(
        "product-sets/" + params.setId + "/prices?catalogId=" + params.catalogId,
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    })
  },

  updatePrices(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put(
        `product-sets/${params.setId}/prices`, params
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    })
  },
  getIronTypes(context, params) {
    context.commit("set_loading");
    return new Promise((resolve,reject) => {
      NewApiService.get(
        `product-sets/iron-types`, params
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        });
    })
  }
};
